
import { CToken } from '../function/axios'

export let cancelCheckDomain
export let cancelGetDomainSuggestions

export default {
  checkDomain: (domain,tlds,action="register") => {
    return window.ccpAxios.post('/api/domain/availability', {
      domain,
      tlds,
      action
    },{
      cancelToken: new CToken(function(c){
        cancelCheckDomain = c
      })
    })
  },
  getDomainSuggestions : (domain,tlds,page=1,limit=5) =>{
    return window.ccpAxios.post( `/api/domain/suggestion?page=${page}&limit=${limit}`, {
      domain,
      tlds
    },{
      cancelToken: new CToken(function(c){
        cancelGetDomainSuggestions = c
      })
    })
  }
}
